import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import {
  IS_API_GATEWAY,
  IS_PRIVATE_API,
} from '@personal-area/global/http/models';

export interface ServerModel {
  id: number;
  name: string;
  address: string;
  type: string;
}

const mtURLs = {
  server: (serverId: number) => `/v1/mt/servers/${serverId}`,
};

@Injectable({ providedIn: 'root' })
export class MtService {
  /**
   * Constructor.
   * @param {HttpClient} _http Client for API calls
   */
  constructor(private _http: HttpClient) {}

  getServer(serverId: number): Observable<ServerModel> {
    return this._http.get<ServerModel>(mtURLs.server(serverId), {
      context: new HttpContext()
        .set(IS_PRIVATE_API, true)
        .set(IS_API_GATEWAY, true),
    });
  }
}
